import { convertToInternationalCurrencySystem, isMobile } from "../../utils/utils";
import { useEffect } from "react";
import dateFormat from "dateformat";
import styled from "styled-components";
import Icon from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";

const Wrapper = styled.div<{ coordinate?: any }>`
  &.custom-tooltip {
    padding: 0 0 0 10px;
    color: #e0ecff;
    z-index: 2;
    .tip-title {
      font-size: 16px;
      color: #e0ecff;
    }
    .value {
      font-size: 32px;
      font-weight: 700;
      font-family: Barlow;
    }
    .date {
      margin-top: 4px;
      margin-left: 4px;
      font-size: 14px;
      height: 14px;
    }
    .text {
      border-bottom: 1px dashed #93a1b8;
      width: max-content;
      cursor: pointer;
      display: block;
    }
    .icon {
      width: 80px;
      height: 80px;
      background: rgba(85, 119, 253, 0.1);
      border: 2px solid #263457;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      position: absolute;
      left: 134px;
      top: 172px;
    }
    @media only screen and (min-width: 383px) and (max-width: 759px) {
      .icon {
        left: calc(50vw - 59px);
      }
    }
  }
`;

const PieTooltip = (props: any) => {
  let {
    title,
    active,
    payload,
    label,
    lastItem,
    decimalScale = 2,
    tip,
    id = String(new Date().getTime()) + Math.random(),
    coordinate,
    isInfo,
  } = props;
  useEffect(() => {
    window.onresize = () => {
      let rect: any = document.querySelector(".graph")?.getBoundingClientRect();
      let icon: any = document.getElementsByClassName("icon")[0];
      if (icon) {
        icon.style.left = isMobile() ? rect.width / 2 - 58 + "px" : rect.width / 3.2 - 60 + "px";
      }
    };
    let rect: any = document.querySelector(".graph")?.getBoundingClientRect();
    let icon: any = document.getElementsByClassName("icon")[0];
    if (icon) {
      icon.style.left = isMobile() ? rect.width / 2 - 58 + "px" : rect.width / 3.2 - 60 + "px";
    }
  }, [props]);
  if (active && payload && payload.length) {
    return (
      <Wrapper className="custom-tooltip" coordinate={active ? coordinate : ""}>
        <div className="tip-title">{title}</div>
        <div className="value">
          {payload[0].payload.name && payload[0].payload.name}
          {tip ? (
            <>
              <span data-for={id} data-tip={tip} className="text">
                {payload[0].payload.value === "NaN"
                  ? 0
                  : convertToInternationalCurrencySystem(
                    payload[0].payload.value,
                    decimalScale
                  )}
              </span>
              <Tooltip id={id} padding="12" place="bottom">
                {" "}
                {tip}{" "}
              </Tooltip>
            </>
          ) : isNaN(payload[0].payload.value) ? (
            0
          ) : (
            convertToInternationalCurrencySystem(
              payload[0].payload.value,
              decimalScale
            )
          )}
        </div>
        <div className="date">
          {payload[0].payload.time &&
            `${dateFormat(
              new Date(payload[0].payload.time * 1000),
              "yyyy-mm-dd"
            )} (UTC)`}
        </div>
        <div className="icon">
          <Icon token={payload[0].payload.name} width={40} />
        </div>
      </Wrapper>
    );
  } else if (title && lastItem.value) {
    return (
      <Wrapper className="custom-tooltip">
        <div className="tip-title">{title}</div>
        <div className="value">
          {" "}
          {lastItem.name && lastItem.name}{" "}
          {tip ? (
            <>
              <span data-for={id} data-tip={tip} className="text">
                {isNaN(lastItem.value)
                  ? 0
                  : convertToInternationalCurrencySystem(
                    lastItem.value,
                    decimalScale
                  )}
              </span>
              <Tooltip id={id} padding="12" place="bottom">
                {" "}
                {tip}{" "}
              </Tooltip>
            </>
          ) : isNaN(lastItem.value) ? (
            0
          ) : (
            convertToInternationalCurrencySystem(lastItem.value, decimalScale)
          )}
        </div>
        <div className="date">
          {lastItem.timestamp &&
            `${dateFormat(
              new Date(lastItem.timestamp * 1000),
              "yyyy-mm-dd"
            )} (UTC)`}
        </div>
        <div className="icon">
          <Icon token={lastItem.name} width={40} />
        </div>
      </Wrapper>
    );
  }
  return null;
};
export default PieTooltip;
